import type { Participant } from '@ember/types';
import { Button } from '../ui/Button.js';

interface LobbyPanelProps {
  waitingParticipants: Participant[];
  onAdmit: (participantId: string) => void;
  onDeny: (participantId: string) => void;
}

export function LobbyPanel({ waitingParticipants, onAdmit, onDeny }: LobbyPanelProps) {
  if (waitingParticipants.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-30 w-72 rounded-xl border border-neutral-700 bg-neutral-900/95 backdrop-blur-sm shadow-xl">
      <div className="px-4 py-3 border-b border-neutral-800">
        <h3 className="text-sm font-semibold text-neutral-100">
          Waiting to join ({waitingParticipants.length})
        </h3>
      </div>
      <ul className="divide-y divide-neutral-800 max-h-64 overflow-y-auto">
        {waitingParticipants.map((p) => (
          <li key={p.participantId} className="flex items-center justify-between gap-2 px-4 py-3">
            <div className="flex items-center gap-2 min-w-0">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutral-700 text-xs font-bold text-neutral-300">
                {p.displayName.slice(0, 2).toUpperCase()}
              </div>
              <span className="truncate text-sm text-neutral-200">{p.displayName}</span>
            </div>
            <div className="flex gap-1.5 shrink-0">
              <Button
                size="sm"
                variant="primary"
                onClick={() => onAdmit(p.participantId)}
              >
                Admit
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => onDeny(p.participantId)}
              >
                Deny
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
